const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://g6hobhkb89.execute-api.us-west-2.amazonaws.com/prod',
    TARGET_API_URL: 'https://cwikh67y1g.execute-api.us-west-2.amazonaws.com/api',
    TEAMS_APP_URL: 'https://teams.staging.newmont.forwoodsafety.com/teams',
    QS_DASHBOARD_URL: '',
    CLIENT_TIMEZONE: 'America/Sao_Paulo'
  },
  reactApp: {
    VERSION: 'targets-1.12.1',
    HOSTNAME: 'https://targets.staging.newmont.forwoodsafety.com'
  }
};

export default config;